<template>
    <img src="/logo.jpg" alt="logo" style="max-width: 450px;">
</template>
